// test1582
(1582 && 0);
